import React from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { MemoryRouter as Router, Switch, Route } from "react-router-dom";
import { connect } from "react-redux";

import MainPage from "./MainPage";
import SavingScreen from "./SavingScreen";

import routesConfig from "../config/routesConfig";

// Styles
import "normalize.css";
import "../css/AppRouter.scss";
import "../css/RouterTransitions.scss";

import Logo from "./Logo";
import ProgressBar from "./ProgressBar";

class AppRouter extends React.Component {
  render() {
    const routeComponents = routesConfig.map(({ path, component }, key) => (
      <Route exact path={path} component={component} key={key} />
    ));
    return (
      <div className="app-wrapper">
        <Router>
          <Route
            render={({ location, history }) => (
              <React.Fragment>
                <TransitionGroup component={null}>
                  <CSSTransition key={location.key} classNames="animate" timeout={1500}>
                    <Switch location={location}>
                      <Route exact path="/" component={MainPage} />
                      <Route exact path="/generating" component={SavingScreen} />
                    </Switch>
                  </CSSTransition>
                </TransitionGroup>

                <Logo />
                <ProgressBar routesConfig={routesConfig} />

                <div className="view-container">
                  <TransitionGroup component={null}>
                    <CSSTransition key={location.key} classNames="slideToLeft fade" timeout={500}>
                      <Switch location={location}>{routeComponents}</Switch>
                    </CSSTransition>
                  </TransitionGroup>
                </div>
              </React.Fragment>
            )}
          />
        </Router>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    progress: state.progress,
  };
};

export default connect(mapStateToProps)(AppRouter);
